<img [src]="imgSrc" alt="" />
<button (click)="dismiss()">
  <ion-icon name="close"></ion-icon>
</button>
